// import node module libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, NavLink, useSearchParams } from 'react-router';
import { Image, Navbar, Nav, Container, Offcanvas } from 'react-bootstrap';

// import sub components
import NavMegaDropdown from './NavMegaDropdown';
import MegaMenu from './MegaMenu';

// import media files
import Logo from '../../../../assets/images/RX_Logo_Black.png';

// import data files
import NavbarDefaultRoutes from '../../../../routes/NavbarDefault';
import ROUTES from '../../../../constants/routes';
import { isObjectNotEmpty } from '../../../../utils/objectUtils';
import { useAuth } from '../../../../redux/ducks/auth';
import QuickMenu from '../../../QuickMenu';
import { useMediaQuery } from 'react-responsive';

const NavbarMegaMenu = () => {
	//#region useAuth

	const { authContext } = useAuth();

	//#endregion
	//#region useSearchParams

	const [searchParams, setSearchParams] = useSearchParams();

	//#endregion

	const [expandedMenu, setExpandedMenu] = React.useState(false);

	const isDesktop = useMediaQuery({
		query: '(min-width: 992px)'
	});

	return (
		<React.Fragment>
			<Navbar
				onToggle={(collapsed) => setExpandedMenu(collapsed)}
				expanded={expandedMenu}
				expand="lg"
				className="navbar-default fixed-top"
			>
				<Container fluid="lg">
					<Navbar.Brand as={Link} to={{ pathname: ROUTES.LANDING, search: searchParams.toString() }}>
						<Image src={Logo} alt="" loading="lazy" style={{ height: 30 }} />
					</Navbar.Brand>
					<Navbar.Toggle aria-controls={`offcanvasNavbar-expand-lg`} />
					<Navbar.Offcanvas
						id={`offcanvasNavbar-expand-lg`}
						aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
						placement="end"
						backdrop={true}
						scroll={true}
						responsive="lg"
						className="w-100 w-xs-75"
					>
						<Offcanvas.Header closeButton className='px-2 px-xs-3 pb-0'>
							<Offcanvas.Title id={`offcanvasNavbarLabel-expand-lg`} className="fs-3">
								<Image src={Logo} alt="" loading="lazy" style={{ height: 30 }} />
							</Offcanvas.Title>
							<div className="ms-0 ms-lg-auto d-none d-xs-flex flex-row d-lg-none align-items-center navbar flex-grow-1">
								{isObjectNotEmpty(authContext.currentAuthUser) ? (
									<>
										<Nav className="d-flex flex-row justify-content-end flex-grow-1 pe-3">
											<QuickMenu />
										</Nav>
									</>
								) : (
									<Nav className="justify-content-end flex-grow-1 pe-3">
										<NavLink to={{ pathname: ROUTES.SIGN_IN, search: searchParams.toString() }}>Sign In</NavLink>
									</Nav>
								)}
							</div>
						</Offcanvas.Header>
						<Offcanvas.Body className="p-2 p-xs-3">
							<div className="ms-0 mt-0 d-flex d-xs-none navbar">
								<div className="d-flex align-items-center">
									{isObjectNotEmpty(authContext.currentAuthUser) ? (
										<>
											<Nav className="ms-auto">
												<QuickMenu />
											</Nav>
										</>
									) : (
										<div className="ms-auto d-flex flex-row">
											<Nav>
												<NavLink to={{ pathname: ROUTES.SIGN_IN, search: searchParams.toString() }}>Sign In</NavLink>
											</Nav>
										</div>
									)}
								</div>
							</div>
							<Nav className="ms-auto">
								{NavbarDefaultRoutes.slice(1, 100).map((item, index) => {
									if (item.children === undefined) {
										return (
											<Nav.Link key={index} as={Link} to={{ pathname: item.link, search: searchParams.toString() }}>
												{item.menuitem}
											</Nav.Link>
										);
									} else {
										return (
											<NavMegaDropdown
												item={item}
												key={index}
												onClick={(value) => setExpandedMenu(value)}
											/>
										);
									}
								})}
								<MegaMenu />
							</Nav>

							<div className="ms-auto mt-3 mt-sm-0 d-none d-lg-flex">
								<div className="d-flex align-items-center">
									{isObjectNotEmpty(authContext.currentAuthUser) ? (
										<>
											<Nav className="ms-auto">
												<QuickMenu />
											</Nav>
										</>
									) : (
										<div className="ms-auto d-flex flex-row">
											<Nav>
												<NavLink to={{ pathname: ROUTES.SIGN_IN, search: searchParams.toString() }}>Sign In</NavLink>
											</Nav>
										</div>
									)}
								</div>
							</div>
						</Offcanvas.Body>
					</Navbar.Offcanvas>
				</Container>
			</Navbar>

			{/* <Navbar
				onToggle={(collapsed) => setExpandedMenu(collapsed)}
				expanded={expandedMenu}
				expand="lg"
				className="navbar-default fixed-top"
			>
				<Container fluid="lg" className="px-3">
					<div className="d-flex">
						<Navbar.Brand as={Link} to={{ pathname: ROUTES.LANDING, search: searchParams.toString() }}>
							<Image src={Logo} alt="" loading="lazy" style={{ height: 30 }} />
						</Navbar.Brand>
					</div>

					<Navbar.Toggle aria-controls="basic-navbar-nav">
						<span className="icon-bar top-bar mt-0"></span>
						<span className="icon-bar middle-bar"></span>
						<span className="icon-bar bottom-bar"></span>
					</Navbar.Toggle>
					<Navbar.Collapse id="basic-navbar-nav">
						<div className="ms-0 ms-lg-auto d-flex d-lg-none align-items-center">
							{isObjectNotEmpty(authContext.currentAuthUser) ? (
								<>
									<Nav>
										<QuickMenu />
									</Nav>
								</>
							) : (
								<div className="d-flex flex-row">
									<Nav>
										<NavLink to={{ pathname: ROUTES.SIGN_IN, search: searchParams.toString() }}>Sign In</NavLink>
									</Nav>
								</div>
							)}
						</div>
						<Nav className="ms-auto">
							{NavbarDefaultRoutes.slice(1, 100).map((item, index) => {
								if (item.children === undefined) {
									return (
										<Nav.Link key={index} as={Link} to={{ pathname: item.link, search: searchParams.toString() }}>
											{item.menuitem}
										</Nav.Link>
									);
								} else {
									return (
										<NavMegaDropdown
											item={item}
											key={index}
											onClick={(value) => setExpandedMenu(value)}
										/>
									);
								}
							})}
							{isDesktop ? <MegaMenu /> : null}
						</Nav>

						<div className="ms-0 ms-lg-auto d-none d-lg-flex align-items-center mt-3 mt-lg-0">
							{isObjectNotEmpty(authContext.currentAuthUser) ? (
								<>
									<Nav>
										<QuickMenu />
									</Nav>
								</>
							) : (
								<div className="d-flex flex-row">
									<Nav>
										<NavLink to={{ pathname: ROUTES.SIGN_IN, search: searchParams.toString() }}>Sign In</NavLink>
									</Nav>
								</div>
							)}
						</div>
					</Navbar.Collapse>
				</Container>
			</Navbar> */}
		</React.Fragment>
	);
};

// Specifies the default values for props
NavbarMegaMenu.defaultProps = {
	headerstyle: 'navbar-default',
	login: false
};

// Typechecking With PropTypes
NavbarMegaMenu.propTypes = {
	headerstyle: PropTypes.string,
	login: PropTypes.bool
};

export default NavbarMegaMenu;
